export default __webpack_public_path__ + "static/media/gift_ideas.94043491.png";